module.exports = {"ui":{"count":{"label":{"one":"listing","many":"listings"}}},"demo":{"isLoading":"Loading...","refetch":"Refetch"},"auth":{"signin":{"subtitle":"Please sign in to access Newsroom.","errors":{"account":"You must use an @avenuehq.com email address to access the Newsroom."}}},"date":{"time":"at 9am","newsletterDateLabel":"Newsletter will be sent on","success":{"title":"Amazing!","body":"The newsletter date has been set for"}}}


//////////////////
// WEBPACK FOOTER
// ./src/intl/resources/en-ca.json
// module id = 895
// module chunks = 0